// handle page binding
export function refresh(model, bindingMap) {
    for (let prop in bindingMap) {
        if (bindingMap[prop].set && typeof(bindingMap[prop].set) === 'function' && bindingMap[prop].el && model[prop]) {
            bindingMap[prop].set(bindingMap[prop].el, model[prop]);
        }
    }
}

//
// helpers
//
export function innerTextById(id) {
    return {
        el: document.getElementById(id),
        set: (el, v) => el.innerText = v
    }
}

export function bySelector(selector, set) {
    return {
        el: document.querySelector(selector),
        set
    }
}

export function byElement(el, set) {
    return {
        el,
        set
    }
}
